/**
 * @module ProductAccessoriesLightBox
 * dependencies:
 * /Creaton.Product/Resources/Private/JavaScript/libs/SlickLightbox/SlickLightbox.js
 *
 */
;(function ProductAccessoriesLightBox() {
    function ProductAccessoriesLightBox($dom) {
        /**
         * // local object availability
         * @type {ProductAccessoriesLightBox }
         * @private
         */
        var _this = this

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            this.renderSlickLightbox()
        }

        /**
         * @method renderSlickLightbox
         * @returns {undefined}
         */
        this.renderSlickLightbox = function () {
            $dom.slickLightbox({
                itemSelector: '[rel="product--accessory--lightbox-item"]',
                navigateByKeyboard: true,
            })
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.ProductAccessoriesLightBox = ProductAccessoriesLightBox
})()

$(document).ready(function () {
    var $productAccessoriesLightBox = $('[rel="product--accessories--lightbox-carousel"]')
    if ($productAccessoriesLightBox.length >= 1) {
        new window.Creaton.ProductAccessoriesLightBox($productAccessoriesLightBox)
    }
})
